const ALPHABET = "0123456789ABCDEFGHJKMNPQRSTVWXYZ"; // Crockford base32

function encodeTime(ms: number, len: number): string {
  let out = "";
  for (let i = len - 1; i >= 0; i--) {
    out = ALPHABET[ms % 32]! + out;
    ms = Math.floor(ms / 32);
  }
  return out;
}

/** 時間可排序的唯一識別碼（ULID 風格）。同一毫秒內以隨機尾碼避免碰撞。 */
export function newId(now: number = Date.now()): string {
  const time = encodeTime(now, 10);
  let rand = "";
  for (let i = 0; i < 6; i++) rand += ALPHABET[Math.floor(Math.random() * 32)];
  return time + rand;
}
